import globalAr from 'utils/locale/common/ar.json';

export default function TranslationsAr() {
  return {
    ...globalAr,
  };
}
